import React from "react";

export default () => {
  return (
    <svg
      t="1677138389416"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="4325"
    >
      <path
        d="M854.045586 853.339354h-68.98494V170.671483h68.57854c18.8479 0 34.137548-15.289648 34.137548-34.137548s-15.289648-34.128517-34.137548-34.128516H647.842153c-18.837063 0-34.126711 15.280617-34.12671 34.128516s15.289648 34.137548 34.12671 34.137548h68.952428v682.667871h-68.952428c-18.837063 0-34.126711 15.291454-34.12671 34.128517 0 18.849706 15.289648 34.137548 34.12671 34.137548h206.172727c18.849706 0.010837 34.139354-15.269779 34.150192-34.115874 0.007225-18.849706-15.271586-34.139354-34.119486-34.150191z"
        p-id="4326"
      ></path>
      <path
        d="M643.543351 733.875999c0-18.849706-15.27881-34.137548-34.12671-34.137548H68.266065V324.266968h541.011497c18.849706 0 34.128517-15.27881 34.128516-34.128517 0-18.8479-15.27881-34.128517-34.128516-34.128517H34.128517C15.27881 256.008128 0 271.288745 0 290.136645v443.739354C0 752.723899 15.27881 768.004516 34.128517 768.004516H609.418447c18.846094-0.001806 34.124904-15.282423 34.124904-34.128517zM989.860646 256.008128h-99.116293c-18.858737 0-34.137548 15.27881-34.137548 34.128517s15.27881 34.128517 34.137548 34.128516h64.987776v375.471484h-64.31225c-18.849706 0-34.128517 15.289648-34.128517 34.137548 0 18.8479 15.27881 34.128517 34.128517 34.128516h98.440767c18.8479 0 34.137548-15.280617 34.137548-34.128516V290.134839c0.001806-18.846094-15.289648-34.126711-34.137548-34.126711z"
        p-id="4327"
      ></path>
    </svg>
  );
};
